// Axios forwards fetchOptions to Request only when using its fetch adapter.
export function profileRequestOptions(url) {
    const path = String(url).split(/[?#]/)[0].replace(/\/+$/, "");
    if (!/(?:^|\/)(?:users\/current|memberships\/corp\/company)$/.test(path)) return {};
    return { adapter: "fetch", fetchOptions: { cache: "no-store" } };
}
